import { Directive, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { arc, Pie, PieArcDatum, select, Selection } from 'd3';
import { Subscription } from 'rxjs';

@Directive()
export abstract class BasePie<T> {
  @ViewChild('chartRef', { static: true })
  protected chartRef: ElementRef<HTMLDivElement>;
  @ViewChild('tooltipRef', { static: true })
  protected tooltipRef: ElementRef<HTMLDivElement>;
  protected svg: Selection<SVGGElement, unknown, null, unknown>;
  protected tooltip: Selection<HTMLDivElement, unknown, null, undefined>;
  protected path: Selection<
    SVGPathElement,
    PieArcDatum<T>,
    SVGGElement,
    unknown
  >;
  protected pie: Pie<unknown, T>;
  protected arc = arc<PieArcDatum<T>>()
    .innerRadius(this.innerRadius)
    .outerRadius(this.radius);

  public dataSubscription = Subscription.EMPTY;

  constructor(
    protected renderer: Renderer2,
    protected radius = 125,
    protected innerRadius = 80
  ) {}

  protected createCanvas(): void {
    this.svg = select(this.chartRef.nativeElement)
      .append('svg')
      .attr('width', this.radius * 2)
      .attr('height', this.radius * 2)
      .append('g')
      .attr('transform', `translate(${this.radius}, ${this.radius})`);
    this.tooltip = select(this.tooltipRef.nativeElement);
  }

  protected clearCanvas(): void {
    select(this.chartRef.nativeElement).select('svg').remove();
  }

  protected setChartDimensions(): void {
    const chartSquare = this.radius * 2;
    this.renderer.setStyle(
      this.chartRef.nativeElement,
      'width',
      `${chartSquare}px`
    );
    this.renderer.setStyle(
      this.chartRef.nativeElement,
      'height',
      `${chartSquare}px`
    );
  }
}
